import React, { Component } from 'react';
import { translate } from 'i18n/i18n';
import { inject, observer } from 'mobx-react';
import CountryFormInput from 'app/components/form/inputs/CountryFormInput';
import InputContainer from 'app/components/form/inputs/utils/InputContainer';
import TextFormInput from '../../../components/form/inputs/TextFormInput';

@translate()
@inject('store')
@observer
class SlipwayInfoTab extends Component {
    render() {
        const { t, store: { slipway } } = this.props;
        const { hiddenFields: { isNationalityHidden, isPlateNumberHidden } } = slipway;

        return (
            <div className="tab-container">
                <InputContainer>
                    <TextFormInput
                        hidden={isPlateNumberHidden}
                        isRequired isAlwaysUppercase
                        moduleStore={slipway}
                        formFieldName={'plateNumber'}
                        setTitle={t('COMMON.ENTER_PLATE')}
                        changeTitle={t('COMMON.CHANGE_PLATE')}
                        title={t('COMMON.CAMPER_PLATE') + ':'}
                    />

                    <CountryFormInput
                        hidden={isNationalityHidden}
                        isRequired isValid preselectPhone
                        moduleStore={slipway} formFieldName={'country'}
                        setTitle={t('COMMON.CHOOSE_NATIONALITY')}
                        changeTitle={t('COMMON.CHANGE_NATIONALITY')}
                        title={t('COMMON.NATIONALITY') + ':'}
                    />
                </InputContainer>
            </div>
        )
    }
}

export default SlipwayInfoTab;
